import { API_TYPES } from "@src/appV2/api";
import { post } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const updateInterviewEtaRequestSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.interviewUpdateEta),
    attributes: z.object({
      etaAt: z.string(),
      message: z.string(),
    }),
  }),
});

export type UpdateInterviewEtaRequest = z.infer<typeof updateInterviewEtaRequestSchema>;

interface UpdateInterviewEtaParams {
  interviewId: string;
  etaAt: Date;
  message: string;
}

export function useUpdateInterviewEta(
  options: UseMutationOptions<unknown, AxiosError, UpdateInterviewEtaParams> = {}
) {
  return useMutation({
    mutationFn: async ({ interviewId, etaAt, message }) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/interviews/${interviewId}/update-eta`,
        data: {
          data: {
            type: "interview-update-eta",
            attributes: {
              etaAt: etaAt.toISOString(),
              message,
            },
          },
        },
        requestSchema: updateInterviewEtaRequestSchema,
        responseSchema: z.unknown(),
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.UPDATE_INTERVIEW_ETA_FAILURE,
    },
    ...options,
  });
}
